import request from '@/utils/request'

// 获取图形验证码
export function getCaptchaUrl() {
  return '/api/user/captcha?t=' + new Date().getTime()
}

// 用户注册
export function register(data) {
  return request({
    url: '/api/user/register',
    method: 'post',
    data
  })
}

// 用户登录
export function login(data) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data
  })
}

// 发送短信验证码
export function sendSmsCode(data) {
  return request({
    url: '/api/user/sms/send',
    method: 'post',
    data
  })
}

// 检查用户名是否存在
export function checkUsername(data) {
  return request({
    url: '/api/user/check-username',
    method: 'post',
    data
  })
}

// 检查手机号是否存在
export function checkMobile(data) {
  return request({
    url: '/api/user/check-mobile',
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: '/api/user/reset-password',
    method: 'post',
    data
  })
}

// 退出登录
export function logout() {
  return request({
    url: '/api/user/logout',
    method: 'post'
  })
}

// 获取当前用户信息
export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get'
  })
}

// 检查登录状态
export function checkLogin() {
  return request({
    url: '/api/user/check',
    method: 'get'
  })
}

// 用户签到
export function userSign() {
  return request({
    url: '/api/sign/do',
    method: 'post'
  })
}

// 获取签到信息
export function getSignInfo() {
  return request({
    url: '/api/sign/info',
    method: 'get'
  })
}

// 获取个人信息
export function getProfile() {
  return request({
    url: '/api/user/profile',
    method: 'get'
  })
}

// 更新个人信息（昵称/签名/头像）
export function updateProfile(data) {
  return request({
    url: '/api/user/profile',
    method: 'put',
    data
  })
}

// 更换手机号
export function updatePhone(data) {
  return request({
    url: '/api/user/phone',
    method: 'put',
    data
  })
}

// 获取我的评论
export function getMyComments(params) {
  return request({
    url: '/api/comment/my',
    method: 'get',
    params
  })
}

// 实名认证
export function verifyIdentity(data) {
  return request({
    url: '/api/user/verify',
    method: 'post',
    data
  })
}

// ==================== 新增 API ====================

// 上传头像
export function uploadAvatar(formData) {
  return request({
    url: '/api/common/upload/avatar',
    method: 'post',
    data: formData
    // 不要手动设置 Content-Type！让浏览器自动设置 multipart/form-data 的 boundary
  })
}

// 获取头像框列表
export function getAvatarFrames() {
  return request({
    url: '/api/user/avatar-frames',
    method: 'get'
  })
}

// 选择头像框
export function updateAvatarFrame(data) {
  return request({
    url: '/api/user/avatar-frame',
    method: 'put',
    data
  })
}

// 关注用户
export function follow(data) {
  return request({
    url: '/api/user/follow',
    method: 'post',
    data
  })
}

// 取消关注
export function unfollow(data) {
  return request({
    url: '/api/user/unfollow',
    method: 'post',
    data
  })
}

// 关注列表
export function getFollowing(params) {
  return request({
    url: '/api/user/following',
    method: 'get',
    params
  })
}

// 粉丝列表
export function getFollowers(params) {
  return request({
    url: '/api/user/followers',
    method: 'get',
    params
  })
}

// 检查关注状态
export function getFollowStatus(params) {
  return request({
    url: '/api/user/follow-status',
    method: 'get',
    params
  })
}